<template>
  <FilterBadge v-bind="{ ...$props, ...$attrs }" icon="fas fa-tasks">
    {{ text }}
  </FilterBadge>
</template>

<script setup lang="ts">
import { computed, type PropType } from "vue";
import { useTranslation } from "@/language/translation";
import StatusFilter from "../../filterImplementations/StatusFilter";
import FilterBadge from "./FilterBadge.vue";

const props = defineProps({
  filter: {
    type: Object as PropType<StatusFilter>,
    required: true,
  },
});
const { t } = useTranslation();
const text = computed(() =>
  props.filter.status
    .map((status) => {
      return t(`views.pdca.${status.toLowerCase()}`);
    })
    .join(", "),
);
</script>

<style lang="scss" scoped></style>
